/**
 * Centralized query keys for Item Price queries
 * 
 * Ensures consistency across all Item Price-related queries and mutations.
 * Prevents cache key mismatches that cause snap-back issues.
 */

export const itemPriceQueryKeys = {
  /**
   * Query key for a single item price detail
   */
  detail: (name: string) => ["item-price", name] as const,
  
  /**
   * Query key for item price list
   */
  list: () => ["item-prices", "list"] as const,
  
  /**
   * Query key for all item price queries (for invalidation)
   */
  all: () => ["item-price"] as const,
};

